import type { DialogContentNode } from "@/v2/framework/dialog/types";
import { getSupplementalsByEntity } from "@/services/supplementals";

type OutcomeTranslationRow = {
  name?: string | null;
  info?: string | null;
  eventMarketOutcomeName?: string | null;
  supplementalNames?: {
    supplementalNameTypeId: string;
    name?: string | null;
    eventMarketOutcomeName?: string | null;
  }[];
};

export const buildOutcomeTranslationFields = () => {
  const nodes: DialogContentNode[] = [
    {
      type: "text-field",
      name: "name",
      label: "table_columns.name",
      placeholder: "Enter name",
    },
    {
      type: "text-field",
      name: "eventMarketOutcomeName",
      label: "table_columns.event_market_outcome_name",
      placeholder: "Enter event market outcome name",
    },
    {
      type: "text-field",
      name: "info",
      label: "table_columns.info",
      placeholder: "Enter info",
    },
  ];

  for (const supplementalNameType of getSupplementalsByEntity("OUTCOME")) {
    nodes.push(
      {
        type: "text-field",
        name: `supplementalName_${supplementalNameType.id}_name`,
        label: `table_columns.${supplementalNameType.name.toLowerCase()}`,
        placeholder: "Enter name",
        valueFormatter: (row: unknown) => {
          const item = row as OutcomeTranslationRow;
          return (
            item.supplementalNames?.find(
              (entry) => String(entry.supplementalNameTypeId) === String(supplementalNameType.id),
            )?.name ?? ""
          );
        },
      },
      {
        type: "text-field",
        name: `supplementalName_${supplementalNameType.id}_eventMarketOutcomeName`,
        label: `table_columns.${supplementalNameType.name.toLowerCase()}_event_market_outcome_name`,
        placeholder: "Enter event market outcome name",
        valueFormatter: (row: unknown) => {
          const item = row as OutcomeTranslationRow;
          return (
            item.supplementalNames?.find(
              (entry) => String(entry.supplementalNameTypeId) === String(supplementalNameType.id),
            )?.eventMarketOutcomeName ?? ""
          );
        },
      },
    );
  }

  return nodes;
};
